import { Box, CircularProgress, Toolbar } from "@material-ui/core";
import PopoverMenu from "./PopoverMenu";

const MainMenu = ({
  menu,
  classes,
  parseTitle,
  loading,
  activePopover,
  setActivePopover,
}) => (
  <Toolbar className={classes.mainMenu}>
    <Box>
      {loading && !menu && (
        <CircularProgress
          color="secondary"
          className={classes.circularProgress}
        />
      )}
      {menu &&
        menu.map((item, index) =>
          item.submenu && item.submenu.length > 0 ? (
            <PopoverMenu
              key={item.url || index}
              parseTitle={parseTitle}
              popoverId={`menu_principal-${index}`}
              item={item}
              classes={classes}
              className={classes.menuItem}
              activePopover={activePopover}
              setActivePopover={setActivePopover}
            />
          ) : (
            <a
              role="menuitem"
              href={item.url}
              key={item.url || index}
              aria-label={item.title}
              className={classes.menuItem}
            >
              {parseTitle(item.title)}
            </a>
          )
        )}
    </Box>
  </Toolbar>
);

export default MainMenu;
